<template>
  <div>
    <v-dialog
      v-model="trade_reasoning.flag"
      width="700"
      height="690"
      :fullscreen="fullscreen"
      :hide-overlay="hideOverlay"
    >
      <v-card class="card" height="690" width="800">
        <div
          class="px-5 py-3"
          style="
            font-size: 22px;
            display: flex;
            background-color: #2d8cff;
            color: white;
            font-weight: 800;
          "
        >
          Update Reasoning
          <v-spacer></v-spacer>
          <v-icon text @click="closeForm()" color="#fff" large style="cursor"
            >mdi-close
          </v-icon>
        </div>
        <div class="trade-data">
          <trade-data
            style="
              box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.12);
              border-radius: 8.42105px;
            "
            :show_button="false"
            :is_user_content="false"
            :showDivider="false"
            :trade_data="trade_detail"
          />
          <label class="py-5">Update Reasoning</label>
          <v-textarea
            outlined
            v-model="reason"
            auto-grow
            :rules="[rules.required]"
            placeholder="Enter trade reasoning"
            class="text__field"
          >
          </v-textarea>
          <div class="d-flex">
            <v-spacer></v-spacer>
            <v-btn
              class="mr-3 button"
              color="#2d8cff"
              x-large
              outlined
              height="40"
              @click="closeForm()"
              >Cancel
            </v-btn>
            <v-btn
              height="40"
              class="button"
              color="#2d8cff"
              x-large
              @click="updateReasoning(trade_detail.id)"
            >
              Update</v-btn
            >
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TradeUserData from "./TradeUserData.vue";
import Axios from "@/api/BaseAxios.js";
import { mapActions } from "vuex";

export default {
  name: "UpdateReasoningForm",
  props: ["trade_detail", "trade_reasoning"],
  components: {
    "trade-data": TradeUserData,
  },
  data: () => ({
    reason: null,
    hideOverlay: false,
    fullscreen: false,
    rules: {
      required: (value) => !!value || "Required.",
    },
  }),
  methods: {
    ...mapActions("snackBar", ["showSnack"]),
    closeForm() {
      this.trade_reasoning.id = null;
      this.trade_reasoning.flag = false;
    },
    updateReasoning() {
      const data = {
        reason: this.reason,
      };
      console.log(data);
      const successHandler = (res) => {
        this.showSnack({
          text: `${res.data.message}`,
          color: "success",
          timeout: 4500,
        });
        this.$emit("reload-trade-data");
        this.trade_reasoning.flag = false;
      };
      const errorHandler = (err) => {
        console.log(err);
      };
      Axios.request_POST(
        `api/trade/update-reasoning/${this.trade_detail.id}`,
        data,
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
  },
  mounted() {
    var w = window.innerWidth;
    if (w < 768) {
      setTimeout(() => {
        this.fullscreen = true;
        this.hideOverlay = true;
      }, 100);
    } else {
      this.fullscreen = false;
      this.hideOverlay = false;
    }
    console.log(this.trade_reasoning, this.trade_detail, "trade details");
  },
};
</script>

<style lang="scss" scoped>
.trade-data {
  margin: 20px;
}

.text__field {
  box-sizing: border-box;
  border-radius: 5px;

  border-color: 0.1% solid #fffcfc;
  margin-bottom: -20px;
  box-sizing: border-box;
  border-radius: 4px;
}
.button {
  text-transform: capitalize;
  color: white;
  letter-spacing: 0px;
  font-weight: 700;
  font-size: 16px;
}
</style>
